module.exports = __webpack_public_path__ + "static/img/SAMPLE.1748ad5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SAMPLE.jpg
// module id = gM79
// module chunks = 1